import _typeof from "@babel/runtime/helpers/typeof";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseIconElement, toLinkIconProps } from '../common';
var LinkIconElement = function LinkIconElement(props) {
  var context = useFlexibleUiContext();
  if (!context) {
    return null;
  }
  if (fg('platform-linking-visual-refresh-v2')) {
    var _data = toLinkIconProps(context === null || context === void 0 ? void 0 : context.linkIcon, context.type);
    return _data ? /*#__PURE__*/React.createElement(BaseIconElement, _extends({}, _data, props, {
      name: ElementName.LinkIcon
    })) : null;
  }
  var data = _typeof(context === null || context === void 0 ? void 0 : context.linkIcon) === 'object' ? context === null || context === void 0 ? void 0 : context.linkIcon : undefined;
  return data ? /*#__PURE__*/React.createElement(BaseIconElement, _extends({}, data, props, {
    name: ElementName.LinkIcon
  })) : null;
};
export default LinkIconElement;